/* eslint-disable object-curly-newline */
import auth from '@app/router/middleware/auth';
import initSentry from '@services/Sentry';
import createRouter from '@app/router';
import App from '@components/App.vue';
import Vue from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia';

import '@plugins/axios';
import '@plugins/veevalidate';
import '@plugins/sweetalert2';
import '@plugins/toast';
import '@plugins/tbskeleton';
import '@plugins/vcalendar';
import '@plugins/bootstrap';
import '@plugins/floatingvue';

import UserEditorLayout from '@app/pages/users/layouts/UserEditorLayout.vue';
import UserList from '@app/pages/users/UserList.vue';
import UserEditorEdit from '@app/pages/users/UserEditorEdit.vue';
import UserEditorInformation from '@app/pages/users/UserEditorInformation.vue';
import UserEditorEmployment from '@app/pages/users/UserEditorEmployment.vue';
import UserEditorPermissions from '@app/pages/users/UserEditorPermissions.vue';
import UserEditorTimecare from '@app/pages/users/UserEditorTimecare.vue';
import UserEditorWorkedHours from '@app/pages/users/UserEditorWorkedHours.vue';
import UserEditorWorkSchedule from '@app/pages/users/UserEditorWorkSchedule.vue';
import UserEditorImageSignature from '@app/pages/users/UserEditorImageSignature.vue';
import UserEditorEmailSignatures from '@app/pages/users/UserEditorEmailSignatures.vue';
import SupplierList from '@app/pages/suppliers/SupplierList.vue';
import PurchaseEditor from '@app/pages/suppliers/PurchaseEditor.vue';
import SupplierComplaintList from '@app/pages/suppliers/ComplaintList.vue';
import SupplierComplaintEdit from '@app/pages/suppliers/ComplaintEdit.vue';
import SupplierPurchasesLayout from '@app/pages/suppliers/layouts/SupplierPurchases.vue';
import PurchaseList from '@app/pages/suppliers/PurchaseList.vue';
import PurchaseItemsList from '@app/pages/suppliers/PurchaseItemsList.vue';
import OutOfStockItemsList from '@app/pages/suppliers/PurchaseSuggestionList.vue';
import SupplierEditorLayout from '@app/pages/suppliers/layouts/SupplierEditor.vue';
import SupplierEditorInfo from '@app/pages/suppliers/SupplierEditorInfo.vue';
import SupplierEditorProducts from '@app/pages/suppliers/SupplierEditorProducts.vue';
import SupplierEditorPurchases from '@app/pages/suppliers/SupplierEditorPurchases.vue';
import ComplaintsIndex from '@app/pages/shipping/ComplaintsIndex.vue';
import ComplaintsList from '@app/pages/shipping/ComplaintsList.vue';
import ComplaintsView from '@app/pages/shipping/ComplaintsView.vue';
import BackordersList from '@app/pages/deliverycenter/BackordersList.vue';
import DeliveryCenter from '@app/pages/deliverycenter/DeliveryCenter.vue';
import PostnordPrognos from '@app/pages/deliverycenter/PostnordPrognos.vue';
import ShippingCostApproval from '@app/pages/economy/ShippingCostApproval.vue';
import ProdOrderSearch from '@app/pages/prodorder/ProdOrderSearch.vue';
import ProdOrderEdit from '@app/pages/prodorder/ProdOrderEdit.vue';
import TodoList from '@app/pages/prodorder/TodoList.vue';
import ProductList from '@app/pages/products/ProductList.vue';
import ProductEditorLayout from '@app/pages/products/layouts/ProductEditor.vue';
import ProductEditorInfo from '@app/pages/products/ProductEditorInfo.vue';
import ProductEditorWeb from '@app/pages/products/ProductEditorWeb.vue';
import ProductEditorPdfInfo from '@app/pages/products/ProductEditorPdfInfo.vue';
import ProductEditorLogistics from '@app/pages/products/ProductEditorLogistics.vue';
import ProductEditorPrices from '@app/pages/products/ProductEditorPrices.vue';
import ProductEditorPurchases from '@app/pages/products/ProductEditorPurchases.vue';
import ProductEditorCards from '@app/pages/products/ProductEditorCards.vue';
import ProductEditorDeliveryStatistics from '@app/pages/products/ProductEditorDeliveryStatistics.vue';
import ProductEditorDeliveryStatus from '@app/pages/products/ProductEditorDeliveryStatus.vue';
import ProductEditorImages from '@app/pages/products/ProductEditorImages.vue';
import ProductEditorLog from '@app/pages/products/ProductEditorLog.vue';
import ProductCodes from '@app/pages/products/ProductCodes.vue';
import ProductCategoryTree from '@app/pages/products/ProductCategoryTree.vue';
import ProductCategoryEdit from '@app/pages/products/ProductCategoryEdit.vue';
import ProductCategorySorter from '@app/pages/products/ProductCategorySorter.vue';
import ProductTypeList from '@app/pages/products/ProductTypeList.vue';
import ProductTypeEdit from '@app/pages/products/ProductTypeEdit.vue';
import ProductCodeTypeList from '@app/pages/products/ProductCodeTypeList.vue';
import ProductCodeTypeEdit from '@app/pages/products/ProductCodeTypeEdit.vue';
import ReturnOrderList from '@app/pages/returnorder/ReturnOrderList.vue';
import ReturnOrderEdit from '@app/pages/returnorder/ReturnOrderEdit.vue';
import SalesCrm from '@app/pages/sales_crm/SalesCrm.vue';
import SalesCrmTodos from '@app/pages/sales_crm/SalesCrmTodos.vue';
import SalesCrmContacts from '@app/pages/sales_crm/SalesCrmContacts.vue';
import SalesCrmCompanies from '@app/pages/sales_crm/SalesCrmCompanies.vue';
import SalesCrmCompany from '@app/pages/sales_crm/SalesCrmCompany.vue';
import AbsenseStatistics from '@app/pages/users/AbsenseStatistics.vue';
import MyTimecare from '@app/pages/users/MyTimecare.vue';
import CardOrderEdit from '@app/pages/cardorder/CardOrderEdit.vue';
import CardOrderList from '@app/pages/cardorder/CardOrderList.vue';
import CardOrderResellerPrices from '@app/pages/cardorder/CardOrderResellerPrices.vue';
import CardOrderActivateCards from '@app/pages/cardorder/CardOrderActivateCards.vue';
import DocumentUpload from '@app/pages/document/DocumentUpload.vue';
import DocumentEdit from '@app/pages/document/DocumentEdit.vue';
import DocumentList from '@app/pages/document/DocumentList.vue';
import DocumentCategoryList from '@app/pages/document/DocumentCategoryList.vue';
import DocumentCategoryEdit from '@app/pages/document/DocumentCategoryEdit.vue';
import CardSerieEdit from '@app/pages/cardseries/CardSerieEdit.vue';
import CardNumberGenerator from '@app/pages/cardseries/CardNumberGenerator.vue';
import CardSerieList from '@app/pages/cardseries/CardSerieList.vue';
import TestCardEdit from '@app/pages/testcards/TestCardEdit.vue';
import TestCardList from '@app/pages/testcards/TestCardList.vue';
import StocktakingEdit from '@app/pages/stocktaking/StocktakingEdit.vue';
import StocktakingList from '@app/pages/stocktaking/StocktakingList.vue';
import StocktakingItem from '@app/pages/stocktaking/StocktakingItem.vue';
import ProductIconList from '@app/pages/products/ProductIconList.vue';
import ProductIconEdit from '@app/pages/products/ProductIconEdit.vue';
import ProductRange from '@app/pages/cardseries/ProductRange.vue';
import ProductRangeSelection from '@app/pages/cardseries/ProductRangeSelection.vue';
import CustomerList from '@app/pages/customers/CustomerList.vue';
import VatReportSales from '@app/pages/economy/VatReportSales.vue';
import VatReportRedeem from '@app/pages/economy/VatReportRedeem.vue';
import VatReportRedeemedCards from '@app/pages/economy/VatReportRedeemedCards.vue';
import CommissionsReport from '@app/pages/economy/CommissionsReport.vue';
import DispatchJobs from '@app/pages/jobs/DispatchJobs.vue';
import JobsStatusList from '@app/pages/jobs/JobsStatusList.vue';
import NtapsBatchPrint from '@app/pages/shipping/NtapsBatchPrint.vue';
import NtapsFileBatchPrint from '@app/pages/shipping/NtapsFileBatchPrint.vue';
import Dashboard from '@app/pages/dashboard/Dashboard.vue';
import CardOrderEcards from '@app/pages/cardorder/CardOrderEcards.vue';
import EcardTemplateEdit from '@app/pages/cardorder/EcardTemplateEdit.vue';
import EcardTemplateList from '@app/pages/cardorder/EcardTemplateList.vue';
import AddressLists from '@app/pages/address_lists/AddressLists.vue';
import AddressListEdit from '@app/pages/address_lists/AddressListEdit.vue';
import BirthdayLists from '@app/pages/birthday_lists/BirthdayLists.vue';
import BirthdayListEdit from '@app/pages/birthday_lists/BirthdayListEdit.vue';
import CustomerEdit from '@app/pages/customers/CustomerEdit.vue';
import NtapsPrintLabel from '@app/pages/shipping/NtapsPrintLabel.vue';
import CardDeptReport from '@app/pages/economy/CardDeptReport.vue';
import { createHead } from '@unhead/vue';
import { UnheadPlugin } from '@unhead/vue/vue2';
import Birthdays from '@app/pages/users/Birthdays.vue';
import MultiUpdateProducts from '@app/pages/products/MultiUpdateProducts.vue';
import StatsCardseries from '@app/pages/economy/StatsCardseries.vue';
import StatsCards from '@app/pages/economy/StatsCards.vue';
import KitchenSchedule from '@app/pages/users/KitchenSchedule.vue';
import NtapsShipmentArchive from '@app/pages/shipping/NtapsShipmentArchive.vue';
import AdyenSettlementReportList from '@app/pages/economy/AdyenSettlementReportList.vue';
import AdyenSettlementReportView from '@app/pages/economy/AdyenSettlementReportView.vue';
import InvoiceList from '@app/pages/invoicing/InvoiceList.vue';
import InvoiceEdit from '@app/pages/invoicing/InvoiceEdit.vue';
import InvoicingPage from '@app/pages/invoicing/InvoicingPage.vue';
import InvoicePreview from '@app/pages/invoicing/InvoicePreview.vue';
import PaymentsList from '@app/pages/invoicing/PaymentsList.vue';
import AuthStatus from '@app/pages/fortnox/AuthStatus.vue';
import ProductBrandList from '@app/pages/products/ProductBrandList.vue';
import ProductBrandEdit from '@app/pages/products/ProductBrandEdit.vue';
import MediabankCategoryList from '@app/pages/mediabank/MediabankCategoryList.vue';
import MediabankCategoryEdit from '@app/pages/mediabank/MediabankCategoryEdit.vue';
import MediabankImageList from '@app/pages/mediabank/MediabankImageList.vue';
import MediabankImageEdit from '@app/pages/mediabank/MediabankImageEdit.vue';
import PrintLetterLabel from '@app/pages/shipping/PrintLetterLabel.vue';
import LabelBatchList from '@app/pages/shipping/LabelBatchList.vue';
import LabelBatchEdit from '@app/pages/shipping/LabelBatchEdit.vue';
import ProductPriceUpdateNPH
    from '@app/pages/products/ProductPriceUpdateNPH.vue';

const filters = require.context('../components/Filters', true, /\.vue$/i);
filters.keys().map((key) => Vue.component(key.split('/').pop().split('.')[0], filters(key).default));

/**
 * Init router
 */
const router = createRouter([
    {
        path: '/address_lists',
        name: 'address_lists.list',
        meta: {
            name: 'Adresslistor',
            menu_tag: 'address_lists',
            middleware: [auth],
            permission: [],
        },
        component: AddressLists,
    },
    {
        path: '/address_lists/:id(\\d+)',
        name: 'address_lists.edit',
        meta: {
            name: 'Adresslistor',
            menu_tag: 'address_lists',
            middleware: [auth],
            permission: [],
        },
        component: AddressListEdit,
        props: true,
    },
    {
        path: '/batch/list',
        name: 'batch.list',
        meta: {
            name: 'Batchlista',
            menu_tag: 'ntaps-label-form',
            middleware: [auth],
        },
        component: NtapsBatchPrint,
    },
    {
        path: '/shipping/filebatchprint',
        name: 'batch.file',
        meta: {
            name: 'Bachutskrift Excel',
            menu_tag: 'ntaps-file-batch-print',
            middleware: [auth],
        },
        component: NtapsFileBatchPrint,
    },
    {
        path: '/shipping/print_label',
        name: 'shipping.print_label',
        meta: {
            name: 'Fraktsedelsutskrift',
            menu_tag: 'ntaps-label-form',
            middleware: [auth],
        },
        component: NtapsPrintLabel,
    },
    {
        path: '/shipping/print_letter',
        name: 'shipping.print_letter',
        meta: {
            name: 'Brevetikettutskrift',
            menu_tag: 'print-letter-label',
            middleware: [auth],
        },
        component: PrintLetterLabel,
    },
    {
        path: '/shipping/shipment_archive',
        name: 'shipping.shipment_archive',
        meta: {
            name: 'Sändningsarkiv',
            menu_tag: 'ntaps-shipment-archive',
            middleware: [auth],
        },
        component: NtapsShipmentArchive,
    },
    {
        path: '/shipping/label_batch',
        name: 'shipping.label_batch_list',
        meta: {
            name: 'Batchlista',
            menu_tag: 'label-batch',
            middleware: [auth],
        },
        component: LabelBatchList,
    },
    {
        path: '/shipping/label_batch/:id(\\d+)',
        name: 'shipping.label_batch',
        meta: {
            name: 'Batchlista',
            menu_tag: 'label-batch',
            middleware: [auth],
        },
        component: LabelBatchEdit,
        props: true,
    },
    {
        path: '/birthday_lists',
        name: 'birthday_lists.list',
        meta: {
            name: 'Födelsedagslistor',
            menu_tag: 'birthday_lists',
            middleware: [auth],
            permission: [],
        },
        component: BirthdayLists,
    },
    {
        path: '/birthday_lists/:id(\\d+)',
        name: 'birthday_lists.edit',
        meta: {
            name: 'Födelsedagslistor',
            menu_tag: 'birthday_lists',
            middleware: [auth],
            permission: [],
        },
        component: BirthdayListEdit,
        props: true,
    },
    {
        path: '/cardseries',
        name: 'cardseries.list',
        meta: {
            name: 'Kortserier',
            menu_tag: 'cardseries',
            middleware: [auth],
            permission: ['red_edit_cardseries'],
        },
        component: CardSerieList,
    },
    {
        path: '/cardseries/:id(\\d+)',
        name: 'cardseries.edit',
        meta: {
            name: 'Kortserier',
            menu_tag: 'cardseries',
            middleware: [auth],
            permission: ['red_edit_cardseries'],
        },
        component: CardSerieEdit,
        props: true,
    },
    {
        path: '/cardseries/cardnumbergenerator',
        name: 'cardseries.cardnumbergenerator',
        meta: {
            name: 'Kortnummergenerator',
            menu_tag: 'cardnumbergenerator',
            middleware: [auth],
            permission: ['red_edit_cardseries'],
        },
        component: CardNumberGenerator,
    },
    {
        path: '/testcards',
        name: 'testcards.list',
        meta: {
            name: 'Testkort',
            menu_tag: 'testcards',
            middleware: [auth],
            permission: ['red_edit_cardseries'],
        },
        component: TestCardList,
    },
    {
        path: '/testcards/:id(\\d+)',
        name: 'testcards.edit',
        meta: {
            name: 'Testkort',
            menu_tag: 'testcards',
            middleware: [auth],
            permission: ['red_edit_cardseries'],
        },
        component: TestCardEdit,
        props: true,
    },
    {
        path: '/cardorders',
        name: 'cardorders.list',
        meta: {
            name: 'Kortbeställningar',
            menu_tag: 'cardorders',
            middleware: [auth],
            permission: ['red_edit_cardorders'],
        },
        component: CardOrderList,
    },
    {
        path: '/cardorders/reseller-prices',
        name: 'cardorders.reseller-prices',
        meta: {
            name: 'Återförsäljarepriser',
            menu_tag: 'reseller-prices',
            middleware: [auth],
            permission: ['red_edit_cardorders'],
        },
        component: CardOrderResellerPrices,
    },
    {
        path: '/cardorders/:id(\\d+)',
        name: 'cardorders.edit',
        meta: {
            name: 'Kortbeställningar',
            menu_tag: 'cardorders',
            middleware: [auth],
            permission: ['red_edit_cardorders'],
        },
        component: CardOrderEdit,
        props: true,
    },
    {
        path: '/cardorders/:id(\\d+)/activate',
        name: 'cardorders.activate',
        meta: {
            name: 'Kortbeställningar',
            menu_tag: 'cardorders',
            middleware: [auth],
            permission: ['red_edit_cardorders'],
        },
        component: CardOrderActivateCards,
        props: true,
    },
    {
        path: '/cardorders/:id(\\d+)/ecards',
        name: 'cardorders.ecards',
        meta: {
            name: 'Kortbeställningar',
            menu_tag: 'cardorders',
            middleware: [auth],
            permission: ['red_edit_cardorders'],
        },
        component: CardOrderEcards,
        props: true,
    },
    {
        path: '/customers',
        name: 'customers.list',
        meta: {
            name: 'Kunder',
            menu_tag: 'customers',
            middleware: [auth],
            permission: ['red_edit_cardorders'],
        },
        component: CustomerList,
    },
    {
        path: '/customers/:id(\\d+)',
        name: 'customers.edit',
        meta: {
            name: 'Kunder',
            menu_tag: 'customers',
            middleware: [auth],
            permission: ['red_edit_cardorders'],
        },
        component: CustomerEdit,
        props: true,
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        meta: {
            name: 'Dashboard',
            menu_tag: 'dashboard',
            middleware: [auth],
        },
        component: Dashboard,
    },
    {
        path: '/deliverycenter',
        redirect: {
            name: 'deliverycenter',
            params: {
                deliveryGroup: 'se',
            },
        },
    },
    {
        path: '/deliverycenter/:deliveryGroup(se|fi|no|dk|eu|de|all)',
        name: 'deliverycenter',
        meta: {
            name: 'Leveranscenter',
            menu_tag: 'deliverycenter',
            middleware: [auth],
        },
        component: DeliveryCenter,
        props: true,
    },
    {
        path: '/deliverycenter/backorders',
        name: 'deliverycenter.backorders',
        meta: {
            name: 'Leveranscenter',
            menu_tag: 'backorders',
            middleware: [auth],
        },
        component: BackordersList,
    },
    {
        path: '/deliverycenter/postnord-prognos',
        name: 'deliverycenter.postnord-prognos',
        meta: {
            name: 'PostNord Prognos',
            menu_tag: 'deliverycenter',
            middleware: [auth],
        },
        component: PostnordPrognos,
    },
    {
        path: '/documents',
        name: 'documents.list',
        meta: {
            name: 'Dokument',
            menu_tag: 'document',
            middleware: [auth],
            permission: ['red_read_documents'],
        },
        component: DocumentList,
    },
    {
        path: '/documents/:uuid([0-9a-fA-F]{8}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{12})',
        name: 'documents.edit',
        meta: {
            name: 'Dokument',
            menu_tag: 'document',
            middleware: [auth],
            permission: ['red_edit_documents'],
        },
        component: DocumentEdit,
        props: true,
    },
    {
        path: '/documents/new',
        name: 'documents.new',
        meta: {
            name: 'Dokument',
            menu_tag: 'document',
            middleware: [auth],
            permission: ['red_edit_documents'],
        },
        component: DocumentEdit,
        props: true,
    },
    {
        path: '/documents/upload',
        name: 'documents.upload',
        meta: {
            name: 'Dokument',
            menu_tag: 'document',
            middleware: [auth],
            permission: ['red_edit_documents'],
        },
        component: DocumentUpload,
    },
    {
        path: '/documents/categories',
        name: 'document_category.list',
        meta: {
            name: 'Dokumentkategorier',
            menu_tag: 'document_category',
            middleware: [auth],
            permission: ['red_edit_document_categories'],
        },
        component: DocumentCategoryList,
    },
    {
        path: '/documents/categories/:id(\\d+)',
        name: 'document_category.edit',
        meta: {
            name: 'Dokumentkategorier',
            menu_tag: 'document_category',
            middleware: [auth],
            permission: ['red_edit_document_categories'],
        },
        component: DocumentCategoryEdit,
        props: true,
    },
    {
        path: '/ecard/templates',
        name: 'ecard.templates',
        meta: {
            name: 'E-kort mallar',
            menu_tag: 'ecard_templates',
            middleware: [auth],
        },
        component: EcardTemplateList,
        props: true,
    },
    {
        path: '/ecard/templates/:id(\\d+)',
        name: 'ecard.template',
        meta: {
            name: 'E-kort mall',
            menu_tag: 'ecard_templates',
            middleware: [auth],
        },
        component: EcardTemplateEdit,
        props: true,
    },
    {
        path: '/economy/report/commissions',
        name: 'economy.report.commissions',
        meta: {
            name: 'Provisionsrapport',
            menu_tag: 'economy_commissions_report',
            middleware: [auth],
        },
        component: CommissionsReport,
    },
    {
        path: '/economy/report/card_debt',
        name: 'economy.report.card_debt',
        meta: {
            name: 'Kortskuld',
            menu_tag: 'economy_card_debt_report',
            middleware: [auth],
        },
        component: CardDeptReport,
    },
    {
        path: '/economy/stats/cardseries/:year?',
        name: 'economy.stats.cardseries',
        meta: {
            name: 'Kortstatistik',
            menu_tag: 'economy_cards_stats',
            middleware: [auth],
        },
        component: StatsCardseries,
        props: true,
    },
    {
        path: '/economy/stats/cards/:cardSeriesId(\\d+)/:year/:mode(redeemed|notredeemed|all)',
        name: 'economy.stats.cards',
        meta: {
            name: 'Kortstatistik',
            menu_tag: 'economy_cards_stats',
            middleware: [auth],
        },
        component: StatsCards,
        props: true,
    },
    {
        path: '/economy/report/vat-sales',
        name: 'economy.report.vat-sales',
        meta: {
            name: 'Momsrapport',
            menu_tag: 'economy_vat_sales',
            middleware: [auth],
            permission: ['red_economy_vat_reports'],
        },
        component: VatReportSales,
    },
    {
        path: '/economy/report/vat-redeem',
        name: 'economy.report.vat-redeem',
        meta: {
            name: 'Momsrapport',
            menu_tag: 'economy_vat_sales',
            middleware: [auth],
            permission: ['red_economy_vat_reports'],
        },
        component: VatReportRedeem,
    },
    {
        path: '/economy/report/vat-redeem/cards/:cardSerieId/:period',
        name: 'economy.report.vat-redeem.cardserie',
        meta: {
            name: 'Momsrapport',
            menu_tag: 'economy_vat_sales',
            middleware: [auth],
            permission: ['red_economy_vat_reports'],
        },
        component: VatReportRedeemedCards,
        props: true,
    },
    {
        path: '/economy/report/adyen-settlement-reports',
        name: 'economy.report.adyen-settlement-report.list',
        meta: {
            name: 'Ekonomi - Adyen utbetalningar',
            menu_tag: 'adyen_settlement_reports',
            middleware: [auth],
            permission: ['red_economy_vat_reports'],
        },
        component: AdyenSettlementReportList,
    },
    {
        path: '/economy/report/adyen-settlement-reports/:id',
        name: 'economy.report.adyen-settlement-report.view',
        meta: {
            name: 'Ekonomi - Adyen utbetalningar',
            menu_tag: 'adyen_settlement_reports',
            middleware: [auth],
            permission: ['red_economy_vat_reports'],
        },
        component: AdyenSettlementReportView,
    },
    {
        path: '/economy/shipping-cost-approval',
        name: 'economy.shipping-cost-approval',
        meta: {
            name: 'Fraktkostnader',
            menu_tag: 'economy_shipping_cost_approval',
            middleware: [auth],
        },
        component: ShippingCostApproval,
    },
    {
        path: '/Invoicing',
        name: 'invoicing',
        meta: {
            name: 'Fakturering',
            menu_tag: 'invoicing',
            middleware: [auth],
        },
        component: InvoicingPage,
    },
    {
        path: '/invoices',
        name: 'invoice.list',
        meta: {
            name: 'Fakturor',
            menu_tag: 'invoices',
            middleware: [auth],
        },
        component: InvoiceList,
    },
    {
        path: '/invoices/:id(\\d+)',
        name: 'invoice.edit',
        meta: {
            name: 'Fakturor',
            menu_tag: 'invoices',
            middleware: [auth],
        },
        component: InvoiceEdit,
        props: true,
    },
    {
        path: '/invoices/preview',
        name: 'invoice.preview',
        meta: {
            name: 'Granska fakturor',
            menu_tag: 'invoices',
            middleware: [auth],
        },
        component: InvoicePreview,
    },
    {
        path: '/invoices/payments',
        name: 'invoice.payments',
        meta: {
            name: 'Inbetalningar',
            menu_tag: 'invoice_payments',
            middleware: [auth],
        },
        component: PaymentsList,
    },
    {
        path: '/jobs/status',
        name: 'jobs.status',
        meta: {
            name: 'Jobbstatus',
            menu_tag: 'jobs_status',
            middleware: [auth],
        },
        component: JobsStatusList,
    },
    {
        path: '/jobs/dispatch',
        name: 'jobs.dispatch',
        meta: {
            name: 'Kör jobb',
            menu_tag: 'jobs_dispatch',
            middleware: [auth],
        },
        component: DispatchJobs,
    },
    {
        path: '/mediabank',
        name: 'mediabank.list',
        meta: {
            name: 'Mediabank',
            menu_tag: 'mediabank',
            middleware: [auth],
            permission: ['red_edit_cardorders', 'red_edit_products'],
        },
        component: MediabankImageList,
    },
    {
        path: '/mediabank/:id(\\d+)',
        name: 'mediabank.edit',
        meta: {
            name: 'Mediabank',
            menu_tag: 'mediabank',
            middleware: [auth],
            permission: ['red_edit_cardorders', 'red_edit_products'],
        },
        component: MediabankImageEdit,
        props: true,
    },
    {
        path: '/mediabank/categories',
        name: 'mediabank.categories',
        meta: {
            name: 'Mediabank',
            menu_tag: 'mediabank',
            middleware: [auth],
            permission: ['red_edit_cardorders', 'red_edit_products'],
        },
        component: MediabankCategoryList,
        props: true,
    },
    {
        path: '/mediabank/categories/:id(\\d+)',
        name: 'mediabank.category',
        meta: {
            name: 'Mediabank',
            menu_tag: 'mediabank',
            middleware: [auth],
            permission: ['red_edit_cardorders', 'red_edit_products'],
        },
        component: MediabankCategoryEdit,
        props: true,
    },
    {
        path: '/prodorders',
        name: 'prodorders.list',
        meta: {
            name: 'Sök kort och prodorder',
            menu_tag: 'prodorders',
            middleware: [auth],
        },
        component: ProdOrderSearch,
    },
    {
        path: '/prodorders/:id(\\d+)',
        name: 'prodorders.edit',
        meta: {
            name: 'Prodorder',
            menu_tag: 'prodorders',
            middleware: [auth],
        },
        component: ProdOrderEdit,
        props: true,
    },
    {
        path: '/prodorders/todo',
        redirect: {
            name: 'prodorders.todo',
            params: {
                deliveryGroup: 'SE',
            },
        },
    },
    {
        path: '/prodorders/todo/:deliveryGroup',
        name: 'prodorders.todo',
        meta: {
            name: 'Att göra',
            menu_tag: 'prodorders_todo',
            middleware: [auth],
        },
        component: TodoList,
        props: true,
    },
    {
        path: '/product_brands',
        name: 'productbrands.list',
        meta: {
            name: 'Varumärken',
            menu_tag: 'product_brands',
            middleware: [auth],
            permission: ['red_edit_products'],
        },
        component: ProductBrandList,
    },
    {
        path: '/product_brands/:id(\\d+)',
        name: 'productbrands.edit',
        meta: {
            name: 'Varumärken',
            menu_tag: 'product_brands',
            middleware: [auth],
            permission: ['red_edit_products'],
        },
        component: ProductBrandEdit,
        props: true,
    },
    {
        path: '/product_icons',
        name: 'producticons.list',
        meta: {
            name: 'Produktikoner',
            menu_tag: 'product_icons',
            middleware: [auth],
            permission: ['red_edit_products'],
        },
        component: ProductIconList,
    },
    {
        path: '/product_icons/:id(\\d+)',
        name: 'producticons.edit',
        meta: {
            name: 'Produktikoner',
            menu_tag: 'product_icons',
            middleware: [auth],
            permission: ['red_edit_products'],
        },
        component: ProductIconEdit,
        props: true,
    },
    {
        path: '/product_range',
        name: 'productrange.list',
        meta: {
            name: 'Produkturval',
            menu_tag: 'product_range',
            middleware: [auth],
            permission: ['red_edit_cardseries', 'red_edit_cardorders'],
        },
        component: ProductRange,
    },
    {
        path: '/product_range/:cardSerieId(\\d+)/:cardOrderId(\\d+)?',
        name: 'productrange.edit',
        meta: {
            name: 'Produkturval',
            menu_tag: 'product_range',
            middleware: [auth],
            permission: ['red_edit_cardseries', 'red_edit_cardorders'],
        },
        component: ProductRangeSelection,
        props: true,
    },
    {
        path: '/products',
        name: 'products.list',
        meta: {
            name: 'Produkter',
            menu_tag: 'products',
            middleware: [auth],
        },
        component: ProductList,
    },
    {
        path: '/products/multiupdate/stock',
        name: 'products.multiupdate.stock',
        meta: {
            name: 'Produkter',
            menu_tag: 'products_multiupdate_stock',
            middleware: [auth],
            permission: ['red_edit_products_extended'],
        },
        component: MultiUpdateProducts,
        props: { mode: 'stock' },
    },
    {
        path: '/products/multiupdate/price',
        name: 'products.multiupdate.price',
        meta: {
            name: 'Produkter',
            menu_tag: 'products_multiupdate_price',
            middleware: [auth],
            permission: ['red_edit_products_extended'],
        },
        component: MultiUpdateProducts,
        props: { mode: 'price' },
    },
    {
        path: '/products/multiupdate/price-nph',
        name: 'products.multiupdate.price-nph',
        meta: {
            name: 'Produkter',
            menu_tag: 'products_multiupdate_price',
            middleware: [auth],
            permission: ['red_edit_products_extended'],
        },
        component: ProductPriceUpdateNPH,
    },
    {
        path: '/products/:id(\\d+)',
        component: ProductEditorLayout,
        children: [
            {
                path: '',
                redirect: {
                    name: 'products.edit',
                },
            },
            {
                path: 'info',
                name: 'products.edit',
                meta: {
                    name: 'Produkter',
                    menu_tag: 'products',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: ProductEditorInfo,
                props: true,
            },
            {
                path: 'web',
                name: 'products.web',
                meta: {
                    name: 'Produkter',
                    menu_tag: 'products',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: ProductEditorWeb,
                props: true,
            },
            {
                path: 'pdfinfo',
                name: 'products.pdfinfo',
                meta: {
                    name: 'Produkter',
                    menu_tag: 'products',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: ProductEditorPdfInfo,
                props: true,
            },
            {
                path: 'logistics',
                name: 'products.logistics',
                meta: {
                    name: 'Produkter',
                    menu_tag: 'products',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: ProductEditorLogistics,
                props: true,
            },
            {
                path: 'prices',
                name: 'products.prices',
                meta: {
                    name: 'Produkter',
                    menu_tag: 'products',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: ProductEditorPrices,
                props: true,
            },
            {
                path: 'purchases',
                name: 'products.purchases',
                meta: {
                    name: 'Produkter',
                    menu_tag: 'products',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: ProductEditorPurchases,
                props: true,
            },
            {
                path: 'cards',
                name: 'products.cards',
                meta: {
                    name: 'Produkter',
                    menu_tag: 'products',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: ProductEditorCards,
                props: true,
            },
            {
                path: 'delivery_statistics',
                name: 'products.delivery_statistics',
                meta: {
                    name: 'Produkter',
                    menu_tag: 'products',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: ProductEditorDeliveryStatistics,
                props: true,
            },
            {
                path: 'delivery_status',
                name: 'products.delivery_status',
                meta: {
                    name: 'Produkter',
                    menu_tag: 'products',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: ProductEditorDeliveryStatus,
                props: true,
            },
            {
                path: 'images',
                name: 'products.images',
                meta: {
                    name: 'Produkter',
                    menu_tag: 'products',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: ProductEditorImages,
                props: true,
            },
            {
                path: 'log',
                name: 'products.log',
                meta: {
                    name: 'Produkter',
                    menu_tag: 'products',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: ProductEditorLog,
                props: true,
            },
        ],
    },
    {
        path: '/products/codes',
        name: 'codes',
        meta: {
            name: 'Produktkoder',
            menu_tag: 'product_codes',
            middleware: [auth],
            permission: ['red_edit_suppliers', 'red_edit_products'],
        },
        component: ProductCodes,
    },
    {
        path: '/products/categories',
        name: 'categories.list',
        meta: {
            name: 'Produkterkategorier',
            menu_tag: 'product_categories',
            middleware: [auth],
            permission: ['red_edit_suppliers', 'red_edit_products'],
        },
        component: ProductCategoryTree,
    },
    {
        path: '/products/categories/sort',
        name: 'categories.sort',
        meta: {
            name: 'Sortera produkterkategorier',
            menu_tag: 'product_categories',
            middleware: [auth],
            permission: ['red_edit_suppliers', 'red_edit_products'],
        },
        component: ProductCategorySorter,
    },
    {
        path: '/product_types',
        name: 'producttypes.list',
        meta: {
            name: 'Produkttyper',
            menu_tag: 'product_types',
            middleware: [auth],
            permission: ['red_edit_products_extended'],
        },
        component: ProductTypeList,
    },
    {
        path: '/product_types/:id(\\d+)',
        name: 'producttypes.edit',
        meta: {
            name: 'Produkttyper',
            menu_tag: 'product_types',
            middleware: [auth],
            permission: ['red_edit_products_extended'],
        },
        component: ProductTypeEdit,
        props: true,
    },
    {
        path: '/product_code_types',
        name: 'productcodetypes.list',
        meta: {
            name: 'Kodtyper',
            menu_tag: 'product_code_types',
            middleware: [auth],
            permission: ['red_edit_products_extended'],
        },
        component: ProductCodeTypeList,
    },
    {
        path: '/product_code_types/:id(\\d+)',
        name: 'productcodetypes.edit',
        meta: {
            name: 'Kodtyper',
            menu_tag: 'product_code_types',
            middleware: [auth],
            permission: ['red_edit_products_extended'],
        },
        component: ProductCodeTypeEdit,
        props: true,
    },
    {
        path: '/products/categories/:id(\\d+)',
        name: 'categories.edit',
        meta: {
            name: 'Produkterkategorier',
            menu_tag: 'product_categories',
            middleware: [auth],
            permission: ['red_edit_suppliers', 'red_edit_products'],
        },
        component: ProductCategoryEdit,
        props: true,
    },
    {
        path: '/returnorders',
        name: 'returnorder.list',
        meta: {
            name: 'Reklamation / Returorder',
            menu_tag: 'returnorder',
            middleware: [auth],
        },
        component: ReturnOrderList,
    },
    {
        path: '/returnorders/:id(\\d+)',
        name: 'returnorder.edit',
        meta: {
            name: 'Reklamation / Returorder',
            menu_tag: 'returnorder',
            middleware: [auth],
        },
        component: ReturnOrderEdit,
        props: true,
    },
    {
        path: '/sales/crm',
        component: SalesCrm,
        children: [
            {
                path: '',
                name: 'crm.init',
                redirect: {
                    name: 'crm.todos',
                },
            },
            {
                path: 'todos',
                name: 'crm.todos',
                meta: {
                    name: 'Att göra',
                    menu_tag: 'sales_crm',
                    middleware: [auth],
                    role: ['red_sales_crm_user'],
                    topbar_color: '#4c0000',
                    sidebar_color: '#310000',
                },
                component: SalesCrmTodos,
            },
            {
                path: 'contacts',
                name: 'crm.contacts',
                meta: {
                    name: 'Kontakter',
                    menu_tag: 'sales_crm',
                    middleware: [auth],
                    role: ['red_sales_crm_user'],
                    topbar_color: '#4c0000',
                    sidebar_color: '#310000',
                },
                component: SalesCrmContacts,
            },
            {
                path: 'companies',
                name: 'crm.companies',
                meta: {
                    name: 'Företag',
                    menu_tag: 'sales_crm',
                    middleware: [auth],
                    role: ['red_sales_crm_user'],
                    topbar_color: '#4c0000',
                    sidebar_color: '#310000',
                },
                component: SalesCrmCompanies,
            },
        ],
    },
    {
        path: '/sales/crm/companies/:id(\\d+)',
        name: 'crm.company',
        meta: {
            name: 'Företag',
            menu_tag: 'sales_crm',
            middleware: [auth],
            role: ['red_sales_crm_user'],
            topbar_color: '#4c0000',
            sidebar_color: '#310000',
        },
        component: SalesCrmCompany,
        props: true,
    },
    {
        path: '/shipping/complaints',
        meta: {
            name: 'Fraktreklamationer',
            menu_tag: 'shipping_complaints',
            middleware: [auth],
        },
        component: ComplaintsIndex,
        showInMenu: true,
        children: [
            {
                path: '',
                redirect: {
                    name: 'shipping.complaints.list',
                },
            },
            {
                path: '/shipping/complaints/list',
                name: 'shipping.complaints.list',
                meta: {
                    name: 'Fraktreklamationer',
                    menu_tag: 'shipping_complaints',
                    middleware: [auth],
                },
                component: ComplaintsList,
                showInMenu: false,
            },
            {
                path: '/shipping/complaints/create/:parcelId',
                name: 'shipping.complaints.create',
                meta: {
                    name: 'Fraktreklamation',
                    menu_tag: 'shipping_complaints',
                    middleware: [auth],
                },
                component: ComplaintsView,
                showInMenu: false,
            },
            {
                path: '/shipping/complaints/:id',
                name: 'shipping.complaints.view',
                meta: {
                    name: 'Fraktreklamation',
                    menu_tag: 'shipping_complaints',
                    middleware: [auth],
                },
                component: ComplaintsView,
                showInMenu: false,
            },
        ],
    },
    {
        path: '/stocktaking',
        name: 'stocktaking.list',
        meta: {
            name: 'Inventering',
            menu_tag: 'stocktaking',
            middleware: [auth],
            permission: ['red_stocktaking'],
        },
        component: StocktakingList,
    },
    {
        path: '/stocktaking/:id(\\d+)',
        name: 'stocktaking.edit',
        meta: {
            name: 'Inventering',
            menu_tag: 'stocktaking',
            middleware: [auth],
            permission: ['red_stocktaking'],
        },
        component: StocktakingEdit,
        props: true,
    },
    {
        path: '/stocktaking/:id(\\d+)/sku/:sku(\\d+)',
        name: 'stocktaking.item',
        meta: {
            name: 'Inventering',
            menu_tag: 'stocktaking',
            middleware: [auth],
            permission: ['red_stocktaking'],
        },
        component: StocktakingItem,
        props: true,
    },
    {
        path: '/suppliers',
        name: 'suppliers.list',
        meta: {
            name: 'Leverantörer',
            menu_tag: 'suppliers',
            middleware: [auth],
            permission: ['red_edit_suppliers', 'red_edit_products'],
        },
        component: SupplierList,
    },
    {
        path: '/suppliers/purchases/:id(\\d+)',
        name: 'suppliers.purchase',
        meta: {
            name: 'Beställningar',
            menu_tag: 'suppliers',
            middleware: [auth],
            permission: ['red_edit_suppliers', 'red_edit_products'],
        },
        component: PurchaseEditor,
        props: true,
    },
    {
        path: '/suppliers/complaints',
        name: 'complaints.list',
        meta: {
            name: 'Produktreklamationer',
            menu_tag: 'supplier_complaints',
            middleware: [auth],
            permission: ['red_edit_suppliers', 'red_edit_products'],
        },
        component: SupplierComplaintList,
        props: true,
    },
    {
        path: '/suppliers/complaints/:id(\\d+)',
        name: 'complaints.edit',
        meta: {
            name: 'Produktreklamation',
            menu_tag: 'supplier_complaints',
            middleware: [auth],
            permission: ['red_edit_suppliers', 'red_edit_products'],
        },
        component: SupplierComplaintEdit,
        props: true,
    },
    {
        path: '/suppliers',
        component: SupplierPurchasesLayout,
        children: [
            {
                path: 'purchases',
                name: 'suppliers.purchases.list',
                meta: {
                    name: 'Beställningar',
                    menu_tag: 'purchases_list',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: PurchaseList,
                props: true,
            },
            {
                path: 'purchases/items',
                name: 'suppliers.purchases.items',
                meta: {
                    name: 'Beställda produkter',
                    menu_tag: 'purchases_items',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: PurchaseItemsList,
                props: true,
            },
            {
                path: 'purchases/purchasesuggestion',
                name: 'suppliers.purchases.purchasesuggestion',
                meta: {
                    name: 'Beställningsunderlag',
                    menu_tag: 'purchases_suggestion',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: OutOfStockItemsList,
                props: true,
            },
        ],
    },
    {
        path: '/suppliers/:id(\\d+)',
        component: SupplierEditorLayout,
        children: [
            {
                path: '',
                redirect: {
                    name: 'suppliers.edit',
                },
            },
            {
                path: 'info',
                name: 'suppliers.edit',
                meta: {
                    name: 'Leverantörer',
                    menu_tag: 'suppliers',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: SupplierEditorInfo,
                props: true,
            },
            {
                path: 'products',
                name: 'suppliers.products',
                meta: {
                    name: 'Leverantörer',
                    menu_tag: 'suppliers',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: SupplierEditorProducts,
                props: true,
            },
            {
                path: 'purchases',
                name: 'suppliers.purchases',
                meta: {
                    name: 'Leverantörer',
                    menu_tag: 'suppliers',
                    middleware: [auth],
                    permission: ['red_edit_suppliers', 'red_edit_products'],
                },
                component: SupplierEditorPurchases,
                props: true,
            },
        ],
    },
    {
        path: '/users',
        name: 'users.list',
        meta: {
            name: 'Användare',
            menu_tag: 'users',
            middleware: [auth],
        },
        component: UserList,
    },
    {
        path: '/users/:id(\\d+)',
        component: UserEditorLayout,
        children: [
            {
                path: '',
                redirect: {
                    name: 'user.edit',
                },
            },
            {
                path: 'edit',
                name: 'user.edit',
                meta: {
                    name: 'Användare',
                    menu_tag: 'users',
                    middleware: [auth],
                },
                component: UserEditorEdit,
                props: true,
            },
            {
                path: 'information',
                name: 'user.information',
                meta: {
                    name: 'Användare',
                    menu_tag: 'users',
                    middleware: [auth],
                    permission: ['red_edit_users_information', 'red_edit_own_information'],
                },
                component: UserEditorInformation,
                props: true,
            },
            {
                path: 'employment',
                name: 'user.employment',
                meta: {
                    name: 'Användare',
                    menu_tag: 'users',
                    middleware: [auth],
                    permission: ['red_edit_users_employment', 'red_edit_own_employment'],
                },
                component: UserEditorEmployment,
                props: true,
            },
            {
                path: 'permissions',
                name: 'user.permissions',
                meta: {
                    name: 'Användare',
                    menu_tag: 'users',
                    middleware: [auth],
                    permission: ['red_edit_users_permissions'],
                },
                component: UserEditorPermissions,
                props: true,
            },
            {
                path: 'timecare',
                name: 'user.timecare',
                meta: {
                    name: 'Användare',
                    menu_tag: 'users',
                    middleware: [auth],
                    permission: ['red_edit_users_timecare', 'red_edit_own_timecare'],
                },
                component: UserEditorTimecare,
                props: true,
            },
            {
                path: 'worked_hours',
                name: 'user.worked_hours',
                meta: {
                    name: 'Användare',
                    menu_tag: 'users',
                    middleware: [auth],
                    permission: ['red_edit_users_timecare', 'red_edit_own_timecare'],
                },
                component: UserEditorWorkedHours,
                props: true,
            },
            {
                path: 'work_schedule',
                name: 'user.work_schedule',
                meta: {
                    name: 'Användare',
                    menu_tag: 'users',
                    middleware: [auth],
                    permission: ['red_edit_users_employment', 'red_edit_own_employment'],
                },
                component: UserEditorWorkSchedule,
                props: true,
            },
            {
                path: 'image_signature',
                name: 'user.image_signature',
                meta: {
                    name: 'Användare',
                    menu_tag: 'users',
                    middleware: [auth],
                    permission: ['red_edit_users_information', 'red_edit_own_information'],
                },
                component: UserEditorImageSignature,
                props: true,
            },
            {
                path: 'email_signatures',
                name: 'user.email_signature',
                meta: {
                    name: 'Användare',
                    menu_tag: 'users',
                    middleware: [auth],
                    permission: ['red_edit_users_information', 'red_edit_own_information'],
                },
                component: UserEditorEmailSignatures,
                props: true,
            },
        ],
    },
    {
        path: '/users/absensestatistics',
        name: 'users.absensestatistics',
        meta: {
            name: 'Frånvarostatistik',
            menu_tag: 'users',
            middleware: [auth],
            permission: ['red_edit_users_timecare'],
        },
        component: AbsenseStatistics,
    },
    {
        path: '/users/birthdays',
        name: 'users.birthdays',
        meta: {
            name: 'Födelsedagar',
            menu_tag: 'users',
            middleware: [auth],
            permission: ['red_edit_users_information'],
        },
        component: Birthdays,
    },
    {
        path: '/users/kitchen_schedule',
        name: 'users.kitchen_schedule',
        meta: {
            name: 'Köksveckor',
            menu_tag: 'users',
            middleware: [auth],
            permission: ['red_edit_users_information'],
        },
        component: KitchenSchedule,
    },
    {
        path: '/users/my-timecare',
        name: 'users.my-timecare',
        meta: {
            name: 'Användare',
            menu_tag: 'users',
            middleware: [auth],
            permission: ['red_edit_own_timecare'],
        },
        component: MyTimecare,
    },
    {
        path: '/fortnox/auth_status',
        name: 'fortnox.auth_status',
        meta: {
            name: 'Fortnox Auth Status',
            menu_tag: 'fortnox_auth_status',
            middleware: [auth],
            permisson: ['red_fortnox_integration'],
        },
        component: AuthStatus,
    },
], '');

initSentry(router);

const head = createHead();
Vue.use(UnheadPlugin);

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

// eslint-disable-next-line no-unused-vars
const app = new Vue({
    pinia,
    router,
    ...App,
    unhead: head,
});
